import { ApiProperty } from "@nestjs/swagger";

export class WorkStationCategoryReq{
    workstationCategory:number;
    unitId?:number;
}